export default __webpack_public_path__ + "static/omni-3-d9e39caf1f179664a99264a7044bd1b8.webp";